import theme from "../styles/theme";

export const mobileScreen = theme.breakpoints.down("md");
export const smallMobileScreen = theme.breakpoints.down("br480");

export const tabletOnlyScreen = theme.breakpoints.between("br480", "md");
export const bigOnlyScreen = theme.breakpoints.up("br1950");
export const mediumOnlyScreen = theme.breakpoints.between("md","xl")